import graphql__13af64ac1de3ec2f4dca from "./__generated__/AppVisibilitySectionQuery.graphql.ts";import { Heading } from '@portal/components'
import { graphql } from 'babel-plugin-relay/macro'
import { useAppToDatabaseRename } from 'components/hooks'
import { useLazyLoadQuery } from 'react-relay/hooks'
import { useAppManagementContext } from 'scenes/appManagement/context'

import { AppVisibilitySectionQuery } from './__generated__/AppVisibilitySectionQuery.graphql'
import AppVisibilityForm from './AppVisibilityForm'

const query = graphql__13af64ac1de3ec2f4dca

export default function AppVisibilitySection() {
  const { appId } = useAppManagementContext()
  const { databaseText } = useAppToDatabaseRename()
  const { viewer } = useLazyLoadQuery<AppVisibilitySectionQuery>(query, {
    appId,
  })

  return (
    <div>
      <Heading level={3}>Change {databaseText} visibility</Heading>
      <p className="text-base text-foreground-subtle">
        Change which role(s) in the org can see your {databaseText}
      </p>

      <AppVisibilityForm
        appId={appId}
        appVisibility={viewer.appById?.visibility || 'EVERYONE'}
      />
    </div>
  )
}
